import { Payment_Gateway_Enum } from 'src/app/models/portal';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { ApiService } from 'src/app/shared/services';

import { SalesLogDetailedElement } from 'src/app/models/system-earnings';
import {
  LearmoModalRef,
  LearmoModalService,
} from 'src/app/shared/services/learmo-modal.service';

@Component({
  selector: 'app-sales-item-popup',
  templateUrl: './sales-item-popup.component.html',
  styleUrls: ['./sales-item-popup.component.css'],
})
export class SalesItemPopupComponent implements OnInit {
  salesPaymentMethodEnum = Payment_Gateway_Enum;

  @Input() saleItem: SalesLogDetailedElement;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalFooter') modalFooter: TemplateRef<any>;
  @Input() modalRef: LearmoModalRef;
  constructor(
    private modalService: LearmoModalService,
    private route: Router,
    private api: ApiService,
    private toastr: ToastrService
  ) {}

  async ngOnInit() {}

  closeModal() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }
  // Affiliate Links List

  // Modal Open
  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      title: `Order Details (#${this.saleItem.id})`,
      icon: 'monitor',
      size: 'fullscreen',
      premium: true,
      footer: this.modalFooter,
    });
  }

  async onOpenModal() {
    // this.resetForm();
    // this.productObject.type_id = 1;
  }

  // FileUpload
}
